import { userIdentity } from '@unipile/db';
import { Static, Type } from '@sinclair/typebox';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';

export const UserIdentitySchema = createSelectSchema(userIdentity);

export const PublicUserIdentitySchema = Type.Omit(UserIdentitySchema, ['user_id', 'provider_user_id', 'id']);

export const InsertUserSocialAuthIdentitySchema = createInsertSchema(userIdentity);

export type UserSocialAuthIdentity = typeof userIdentity.$inferSelect;
export type PublicUserSocialAuthIdentity = Static<typeof PublicUserIdentitySchema>;
export type InsertUserSocialAuthIdentity = typeof userIdentity.$inferInsert;
